import {
  Box,
  Grid,
  Stack,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { translateDate } from './utils';

const Card = styled('div')(({ isSmDown }) => ({
  padding: isSmDown ? 16 : 20,
  width: '100%',
  minHeight: 100,
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'relative',
}));

const TicketBoughtCard = ({ ticket, locale, actionsContainer = null }) => {
  const intl = useIntl();
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const i18nCommon = translations.TicketsV2(intl).Common;

  const TitleValueComponent = ({ title, children }) => (
    <Stack>
      <Typography
        variant="s-bold"
        color={'#333333'}
        textTransform={'uppercase'}
        marginBottom={'0px'}
      >
        {title}
      </Typography>
      {children}
    </Stack>
  );

  return (
    <Card isSmDown={isSmDown}>
      {ticket.isMerch || ticket.isAccount ? (
        <Box marginBottom={'24px'}>
          <div
            style={{
              backgroundColor: theme.palette.grey[200],
              color: 'black',
              borderRadius: '25px',
              width: 'fit-content',
              display: 'flex',
              padding: '5px 10px',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <Typography variant="xs-bold" textAlign="center">
              {i18nCommon.accountOwner}
            </Typography>
          </div>
        </Box>
      ) : null}
      <Grid container>
        <Grid
          item
          md={4}
          sm={12}
          xs={12}
          marginBottom={isMdDown ? '24px' : '0px'}
        >
          <Typography variant="m-bold" marginBottom={1.5}>
            {ticket.owner}
          </Typography>
          <Typography paragraph variant="link2">
            {i18nCommon[ticket.role]}
          </Typography>
        </Grid>
        <Grid
          item
          md={2}
          sm={4}
          xs={12}
          marginBottom={isSmDown ? '8px' : '0px'}
        >
          <TitleValueComponent title={i18nCommon.product}>
            <Typography variant="link2">{ticket.description}</Typography>
            {ticket.dates ? (
              <Typography variant="link2">
                <strong>
                  {translateDate({ datesArray: ticket.dates, locale })}
                </strong>
              </Typography>
            ) : null}
          </TitleValueComponent>
        </Grid>
        <Grid
          item
          md={1}
          sm={4}
          xs={12}
          marginBottom={isSmDown ? '8px' : '0px'}
        >
          <TitleValueComponent title={i18nCommon.price}>
            <Typography variant="link2">{ticket.price}</Typography>
          </TitleValueComponent>
        </Grid>
        <Grid
          item
          md={1}
          sm={4}
          xs={12}
          marginBottom={isSmDown ? '8px' : '0px'}
        >
          <TitleValueComponent title={i18nCommon.quantity}>
            <Typography variant="link2">{ticket.quantity}</Typography>
          </TitleValueComponent>
        </Grid>
        {actionsContainer ? (
          <Grid
            item
            md={4}
            sm={12}
            xs={12}
            marginTop={isMdDown ? '24px' : '0px'}
          >
            {actionsContainer}
          </Grid>
        ) : !isMdDown ? (
          <Grid item md={4}></Grid>
        ) : null}
      </Grid>
    </Card>
  );
};
export { TicketBoughtCard };
